import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeclineReason } from 'ng2-app/models/dto/decline-reason.model';
import { DeclineInfoDialogComponent } from 'ng2-app/components/decline-info-dialog/decline-info-dialog.component';

@Component({
  selector: 'app-decline-info-tooltip',
  templateUrl: './decline-info-tooltip.component.html',
  styleUrls: ['./decline-info-tooltip.component.scss'],
  standalone: false
})
export class DeclineInfoTooltipComponent {
  @Input() declineReasons: DeclineReason[];

  constructor(
    private dialog: MatDialog,
  ) { }

  openDialog(event: Event) {
    event.stopPropagation();
    this.dialog.open(DeclineInfoDialogComponent, {
      width: '620px',
      data: {
        declineReasons: this.declineReasons,
      },
    });
  }
}
